import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository } from 'typeorm';
import { QAQCFibreAnalysisEntity } from './entities/qaqc-fibre-analysis.entity';
import { QAQCFibreLabAnalysisEntity } from './entities/qaqc-fibre-lab-analysis.entity';
import { CreateQaqcFibreAnalysisDto, UpdateQaqcFibreAnalysisDto } from './dto/qaqc-fibre-analysis.dto';
import { CreateQaqcFibreLabAnalysisDto, UpdateQaqcFibreLabAnalysisDto } from './dto/qaqc-fibre-lab-analysis.dto';
import { CreateQaqcProductCountsDto, UpdateQaqcProductCountsDto } from './dto/qaqc-products-counts.dto';

import { QaqcApprovalDto } from './dto/qaqc-approval.dto';
import { WorkOrderInfo } from '../work-order-generation/work-order.entity';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { Not } from 'typeorm';
import { ProductionInventory } from '../../../../production/src/app/operations-track/entities/production-inventory.entity';
import appSettings from 'apps/services/config';
import { QaqcLotReq, QaqcWorkOrderReq } from '@gtpl/shared-services/raw-material-procurement';
import { QAQCProductCountsEntity } from './entities/qaqc-product-counts-entity';
@Injectable()
export class QaqcAnalysisService {
    constructor(
        @InjectRepository(QAQCFibreAnalysisEntity)
        private fibreAnalysisRepository: Repository<QAQCFibreAnalysisEntity>,
        @InjectRepository(QAQCFibreLabAnalysisEntity)
        private fibreLabAnalysisRepository: Repository<QAQCFibreLabAnalysisEntity>,
        @InjectRepository(WorkOrderInfo)
        private workOrderRepository: Repository<WorkOrderInfo>,
        @InjectRepository(QAQCProductCountsEntity)
        private QAQCProductCountsEntityRepository: Repository<QAQCProductCountsEntity>,
    ) { }

    async getWorkOrdersForQAQC(req: QaqcWorkOrderReq): Promise<CommonResponse> {
        try {
                let query = `SELECT pi.prod_inv_id as productionInventoryId,pi.work_order_no as workOrderNo,
                wo.work_order_date as workOrderDate,pi.physical_quantity as totalQty,
                pi.quality,pi.is_qaqc_one_done as isQAQCOneDone,pi.out_product as outProduct,
                pi.is_qaqc_two_done as isQAQCTwoDone,pi.is_qaqc_approved as isQAQCApproved,
                p.name as product
                FROM ${appSettings.production_db}.production_inventory pi 
                LEFT JOIN ${appSettings.rm_procure_db}.work_order_info wo ON wo.work_order_no = pi.work_order_no
                LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=pi.out_product
                WHERE pi.lot_number ='N/A' AND pi.operation='DEGUMMING'
                AND pi.entry_type='OUT' 
                AND (pi.physical_quantity - pi.issued_quantity -  pi.clubbed_quantity) > 0
                AND (pi.is_qaqc_two_done = 0)
                `
                if (req.fromDate && req.toDate != undefined) {
                    query += ` AND wo.work_order_date BETWEEN '${req.fromDate} 00:00:00' AND '${req.toDate} 23:59:59'`;
                }
                if(req.workOrderNo){
                    query += ` and wo.work_order_no = '${req.workOrderNo}'`
                }
                if(req.variant){
                    query += ` and pi.out_product = '${req.variant}'`
                }
                if(req.quality){
                    query += ` and pi.quality = '${req.quality}'`
                }
                // query += ` GROUP BY wo.id ORDER BY wo.id DESC`;
                

                    const data1 = await getManager().query(query);
            return new CommonResponse(true, 200, 'Work orders retrieved successfully', data1);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    async getWorkOrdersDropdownForQAQC(): Promise<CommonResponse> {
        try {
                const querry = `SELECT DISTINCT wo.id as workOrderId,wo.work_order_no as workOrderNo
                FROM ${appSettings.rm_procure_db}.work_order_info wo
                
                WHERE wo.id > 0
                
                GROUP BY wo.id
                ORDER BY wo.id DESC`;
                const data1 = await getManager().query(querry);
            return new CommonResponse(true, 200, 'Work orders retrieved successfully', data1);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }



    async getLotsForQAQC(req:QaqcLotReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
             
            let query = `
      SELECT 
        pi.prod_inv_id AS productionInventoryId,
        pi.lot_number AS lotNumber,
        pi.physical_quantity AS physicalQuantity,
        sku.short_code as product,
        pi.plant_id AS plantId,pi.prev_operation as prevOperation,pi.operation,pi.quality,
        pi.is_qaqc_one_done AS isQAQCOneDone,
        pi.is_qaqc_two_done AS isQAQCTwoDone,
        pi.out_product as outProduct
         FROM ${appSettings.production_db}.production_inventory pi
         LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id=pi.out_product
      WHERE pi.lot_number != 'N/A' 
      AND pi.entry_type = 'OUT'
      AND (pi.is_qaqc_one_done = 0)
      
    `
            
                if(req.lotNumber){
                    query += ` and pi.lot_number = '${req.lotNumber}'`
                }
                if(req.variant){
                    query += ` and pi.out_product = '${req.variant}'`
                }
                if(req.quality){
                    query += ` and pi.quality = '${req.quality}'`
                }
                query += ` ORDER BY pi.prod_inv_id DESC`;
    const data = await manager.query(query);


            return new CommonResponse(
                true,
                200,
                data.length ? 'Lots retrieved successfully' : 'No lots found',
                data
            );
        } catch (error: any) {
            console.error('QAQC Lots Error:', error);

            return new CommonResponse(
                false,
                500,
                error?.message || 'Internal server error'
            );
        }
    }

    async getLotsForProductCountsQAQC(req:QaqcLotReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
             
            let query = `
      SELECT 
        prod_inv_id AS productionInventoryId,
        lot_number AS lotNumber,
        physical_quantity AS physicalQuantity,
        sku.sku_code_id as skuCodeId,
        sku.short_code as product,
        plant_id AS plantId,prev_operation as prevOperation,operation,quality,
        is_qaqc_one_done AS isQAQCOneDone,
        is_qaqc_two_done AS isQAQCTwoDone
         FROM ${appSettings.production_db}.production_inventory
        LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id=production_inventory.out_product      
        WHERE lot_number != 'N/A' 
      AND entry_type = 'OUT'
      AND (is_qaqc_three_done = 0)
      
    `
            
                if(req.lotNumber){
                    query += ` and lot_number = '${req.lotNumber}'`
                }
                if(req.variant){
                    query += ` and sku.sku_code_id = '${req.variant}'`
                }
                if(req.quality){
                    query += ` and quality = '${req.quality}'`
                }
                query += ` ORDER BY prod_inv_id DESC`;
    const data = await manager.query(query);


            return new CommonResponse(
                true,
                200,
                data.length ? 'Lots retrieved successfully' : 'No lots found',
                data
            );
        } catch (error: any) {
            console.error('QAQC Lots Error:', error);

            return new CommonResponse(
                false,
                500,
                error?.message || 'Internal server error'
            );
        }
    }
    async getLotsDropdownForQAQC(): Promise<CommonResponse> {
        try {
            const manager = getManager();

            const data = await manager.query(`
      SELECT DISTINCT
        
        lot_number AS lotNumber
        
         FROM ${appSettings.production_db}.production_inventory
      WHERE lot_number != 'N/A'
         
      ORDER BY prod_inv_id DESC
    `);

            return new CommonResponse(
                true,
                200,
                data.length ? 'Lots retrieved successfully' : 'No lots found',
                data
            );
        } catch (error: any) {
            console.error('QAQC Lots Error:', error);

            return new CommonResponse(
                false,
                500,
                error?.message || 'Internal server error'
            );
        }
    }



    // Create fibre analysis
    async createFibreAnalysis(createDto: CreateQaqcFibreAnalysisDto): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const testType = createDto.lotNumber ? 'lot' : createDto.workOrderNo ? 'work_order' : null;
            if (!testType) return new CommonResponse(false, 400, 'Either lotNumber or woNumber is required');
            const analysis = this.fibreAnalysisRepository.create({
                ...createDto,
                analysisType: 'SILKFIBERANALYSIS',
                testType
            });
            const saved = await this.fibreAnalysisRepository.save(analysis);
            if (saved) {
                await manager.query(
                    `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_one_done = 1 WHERE prod_inv_id = ?`,
                    [createDto.productionInventoryId]
                );
            }
            

            return new CommonResponse(true, 201, 'Fibre analysis created successfully', saved);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }


    async createFibreLabAnalysis(createDto: CreateQaqcFibreLabAnalysisDto): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const testType = createDto.lotNumber ? 'lot' : createDto.workOrderNo ? 'work_order' : null;
            if (!testType) return new CommonResponse(false, 400, 'Either lotNumber or woNumber is required');
            const analysis = this.fibreLabAnalysisRepository.create({
                ...createDto,
                 workOrderNo: createDto.workOrderNo,
                analysisType: 'SILKFIBERLABANALYSIS',
                testType
            });
            const saved = await this.fibreLabAnalysisRepository.save(analysis);
            if (saved) {
                await manager.query(
                    `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_two_done = 1 WHERE prod_inv_id = ?`,
                    [createDto.productionInventoryId]
                );
            }
            
            return new CommonResponse(true, 201, 'Fibre lab analysis created successfully', saved);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    async getAllFibreAnalysis(req: any): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
        SELECT 
            fa.id,
            DATE_FORMAT(fa.test_date, '%d-%m-%Y') AS testDate,
            fa.lot_number AS lotNumber,
            fa.operation,
            fa.prev_operation AS prevOperation,
            sku.short_code AS product,
            fa.quality,
            fa.mean_length AS meanLength,
            fa.shortest_fiber AS shortestFiber,
            fa.longest_fiber AS longestFiber,
            fa.short_fiber_percent AS shortFiberPercent,
            fa.slub,
            fa.quantity,
            fa.test_type AS testType,
            fa.analysis_type AS analysisType,
            fa.remarks,
            fa.is_qaqc_approved AS isQAQCApproved,
            fa.product as productId
        FROM ${appSettings.rm_procure_db}.qaqc_fibre_analysis fa
        LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id=fa.product
        WHERE fa.test_type='lot'
        `
        if (req.fromDate && req.toDate != undefined) {
            query += ` AND DATE(fa.created_at) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
        if (req.lotNumber) {
            query += ` and fa.lot_number = '${req.lotNumber}'`
        }
        if (req.variant) {
            query += ` and fa.product = '${req.variant}'`
        }
        if (req.quality) {
            query += ` and fa.quality = '${req.quality}'`
        }
        query += ` ORDER BY fa.test_date DESC`
        const data = await manager.query(query);

        return new CommonResponse(
            true,
            200,
            'Fibre analysis records retrieved successfully',
            data
        );
    } catch (error) {
        return new CommonResponse(false, 500, error.message);
    }
}

    // Get all fibre lab analysis records
    async getAllFibreLabAnalysis(req: any): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
        SELECT 
            fla.id,
            DATE_FORMAT(fla.test_date, '%d-%m-%Y') AS testDate,
            fla.work_order_no AS workOrderNo,
            p.name AS product,
            fla.quantity,
            fla.quality,
            fla.test_type AS testType,
            fla.analysis_type AS analysisType,
            fla.oil_test AS oilTest,
            fla.oil_test_remarks AS oilTestRemarks,
            fla.sericin_test AS sericinTest,
            fla.sericin_test_remarks AS sericinTestRemarks,
            fla.acidity_test AS acidityTest,
            fla.acidity_test_remarks AS acidityTestRemarks,
            fla.pp_content AS ppContent,
            fla.pp_content_remarks AS ppContentRemarks,
            fla.moisture_content AS moistureContent,
            fla.moisture_content_remarks AS moistureContentRemarks,
            fla.is_qaqc_approved AS isQAQCApproved,
            fla.product as productId
        FROM ${appSettings.rm_procure_db}.qaqc_fibre_lab_analysis fla
        LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=fla.product
        WHERE fla.test_type='work_order'
        `
        if (req.fromDate && req.toDate != undefined) {
            query += ` AND DATE(fla.created_at) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
        if (req.workOrderNo) {
            query += ` and fla.work_order_no = '${req.workOrderNo}'`
        }
        if (req.variant) {
            query += ` and fla.product = '${req.variant}'`
        }
        if (req.quality) {
            query += ` and fla.quality = '${req.quality}'`
        }
        query += ` ORDER BY fla.test_date DESC`
        const data = await manager.query(query);

        return new CommonResponse(
            true,
            200,
            'Fibre lab analysis records retrieved successfully',
            data
        );
    } catch (error) {
        return new CommonResponse(false, 500, error.message);
    }
}

    // Get fibre analysis by work order
    async getFibreAnalysisByWorkOrder(workOrderNo: string): Promise<CommonResponse> {
        try {
            const data = await this.fibreAnalysisRepository.find({
                where: { workOrderNo, isActive: true },
                order: { createdAt: 'DESC' }
            });
            return new CommonResponse(true, 200, 'Fibre analysis by work order retrieved successfully', data);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    // Get fibre analysis by lot
    async getFibreAnalysisByLot(lotNumber: string): Promise<CommonResponse> {
        try {
            const data = await this.fibreAnalysisRepository.find({
                where: { lotNumber, isActive: true },
                order: { createdAt: 'DESC' }
            });
            return new CommonResponse(true, 200, 'Fibre analysis by lot retrieved successfully', data);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    // Get fibre lab analysis by work order
    async getFibreLabAnalysisByWorkOrder(workOrderNo: string): Promise<CommonResponse> {
        try {
            const data = await this.fibreLabAnalysisRepository.find({
                where: { workOrderNo, isActive: true },
                order: { createdAt: 'DESC' }
            });
            return new CommonResponse(true, 200, 'Fibre lab analysis by work order retrieved successfully', data);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    // Get fibre lab analysis by lot
    async getFibreLabAnalysisByLot(lotNumber: string): Promise<CommonResponse> {
        try {
            const data = await this.fibreLabAnalysisRepository.find({
                where: { lotNumber, isActive: true },
                order: { createdAt: 'DESC' }
            });
            return new CommonResponse(true, 200, 'Fibre lab analysis by lot retrieved successfully', data);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    // Update fibre analysis
    async updateFibreAnalysis(
  updateDto: UpdateQaqcFibreAnalysisDto
): Promise<CommonResponse> {
  try {
    const existing = await this.fibreAnalysisRepository.findOne({
      where: { id: updateDto.id },
    });

    if (!existing) {
      return new CommonResponse(false, 404, 'Record not found');
    }

    existing.meanLength = updateDto.meanLength;
    existing.shortestFiber = updateDto.shortestFiber;
    existing.longestFiber = updateDto.longestFiber;
    existing.shortFiberPercent = updateDto.shortFiberPercent;
    existing.slub = updateDto.slub;
    existing.remarks = updateDto.remarks;

    const saved = await this.fibreAnalysisRepository.save(existing);

    return new CommonResponse(
      true,
      200,
      'Fibre analysis updated successfully',
      saved
    );
  } catch (error) {
    return new CommonResponse(false, 500, error.message);
  }
}

    // Update fibre lab analysis
    async updateFibreLabAnalysis(
  updateDto: UpdateQaqcFibreLabAnalysisDto
): Promise<CommonResponse> {
  try {
    const existing = await this.fibreLabAnalysisRepository.findOne({
      where: { id: updateDto.id },
    });

    if (!existing) {
      return new CommonResponse(false, 404, 'Record not found');
    }

  
    existing.oilTest = updateDto.oilTest;
    existing.oilTestRemarks = updateDto.oilTestRemarks;
    existing.sericinTest = updateDto.sericinTest;
    existing.sericinTestRemarks = updateDto.sericinTestRemarks;
    existing.acidityTest = updateDto.acidityTest;
    existing.acidityTestRemarks = updateDto.acidityTestRemarks;
    existing.ppContent = updateDto.ppContent;
    existing.ppContentRemarks = updateDto.ppContentRemarks;
    existing.moistureContent = updateDto.moistureContent;
    existing.moistureContentRemarks = updateDto.moistureContentRemarks;

    const saved = await this.fibreLabAnalysisRepository.save(existing);

    return new CommonResponse(
      true,
      200,
      'Fibre lab analysis updated successfully',
      saved
    );
  } catch (error) {
    return new CommonResponse(false, 500, error.message);
  }
}

    // Approve QAQC test
    async approveQaqcTest(approvalDto: QaqcApprovalDto): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const { id, testType, analysisType , workOrderNo, lotNumber, productId } = approvalDto;

            if (analysisType === 'SILKFIBERANALYSIS') {
                const analysis = await this.fibreAnalysisRepository.findOne({ where: { id } });

                if (!analysis) throw new Error('Fibre analysis not found');

                if (analysis.lotNumber) 
                {
                    await manager.query(
                    `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_approved = 1 WHERE lot_number = ? AND out_product = ? AND entry_type='OUT' AND operation = ?`,
                    [analysis.lotNumber,approvalDto.productId, analysis.operation]

                    );
                    await this.fibreAnalysisRepository.update(
                        { id: analysis.id },
                        { isQAQCApproved: true }
                    );
                } 
                else {
                    await manager.query(
                        `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_approved = 1 WHERE work_order_no = ? AND entry_type='OUT' AND out_product = ?`,
                        [approvalDto.workOrderNo, productId]

                    );
                    await this.fibreAnalysisRepository.update(
                        { id: analysis.id },
                        { isQAQCApproved: true }
                    );
                }
            } else if (analysisType === 'SILKFIBERLABANALYSIS') {
                const analysis = await this.fibreLabAnalysisRepository.findOne({ where: { id } });
                if (!analysis) throw new Error('Fibre lab analysis not found');

                if (analysis.lotNumber) {
                    await manager.query(
                    `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_two_approved = 1 WHERE lot_number = ? AND out_product = ? AND entry_type='OUT' AND operation = ?`,
                    [analysis.lotNumber,approvalDto.productId, analysis.operation]
                );
                await this.fibreLabAnalysisRepository.update(
                        { id: analysis.id },
                        { isQAQCApproved: true }
                    );
                } else {
                    await manager.query(
                        `UPDATE ${appSettings.production_db}.production_inventory SET is_qaqc_two_approved = 1 WHERE work_order_no = ? AND lot_number='N/A' 
                        AND operation='DEGUMMING' AND entry_type='OUT' AND out_product = ?`,
                        [approvalDto.workOrderNo, approvalDto.productId]


                    );
                    await this.fibreLabAnalysisRepository.update(
                        { id: analysis.id },
                        { isQAQCApproved: true }
                    );
                }
            }

            return new CommonResponse(true, 200, 'QAQC test approved successfully');
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }



  async createProductCounts(
  createDto: CreateQaqcProductCountsDto
): Promise<CommonResponse> {
  try {
    const manager = getManager();
    const entities: QAQCProductCountsEntity[] = [];

    const { items, ...commonData } = createDto;

    if (items && items.length > 0) {
      for (const item of items) {
        const entity = this.QAQCProductCountsEntityRepository.create({
          ...commonData,
          processType: item.processType || '',
          weightInGms: item.weightInGms,
          count: item.count,
          productType: commonData.productType || '',
        });

        entities.push(entity);
      }
    } else {
      const entity = this.QAQCProductCountsEntityRepository.create({
        ...commonData,
        productType: commonData.productType || '',
      });

      entities.push(entity);
    }

    const saved =
      await this.QAQCProductCountsEntityRepository.save(entities);

    if (createDto.lotNumber) {
      await manager.query(
        `UPDATE ${appSettings.production_db}.production_inventory
         SET is_qaqc_three_done = 1 
         WHERE lot_number = ? AND entry_type='OUT' AND operation = ?`,
        [createDto.lotNumber, createDto.operation]
      );
    }

    return new CommonResponse(
      true,
      201,
      'Product counts created successfully',
      saved
    );
  } catch (error) {
    return new CommonResponse(false, 500, error.message);
  }
}
async getProductCounts(req: any): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
            SELECT 
                qpc.id,
                qpc.test_date AS testDate,
                qpc.process_type AS processType,
                qpc.lot_number AS lotNumber,
                qpc.operation,
                qpc.product,
                qpc.quality,
                qpc.quantity,
                qpc.product_type AS productType,
                qpc.weight_in_gms AS weightInGms,
                qpc.count,
                qpc.is_qaqc_approved AS isQAQCApproved,
                qpc.created_at AS createdAt,
                sku.short_code as productShortCode,
                sku.sku_code_id as skuCodeId
            FROM ${appSettings.rm_procure_db}.qaqc_product_counts qpc
            LEFT JOIN ${appSettings.masters_db}.sku_codes sku ON sku.sku_code_id = qpc.product
            WHERE qpc.id > 0
        `;

        if (req.lotNumber) {
            query += ` AND lot_number = '${req.lotNumber}'`;
        }

        if (req.product) {
            query += ` AND qpc.product = ${req.product}`;
        }

        if (req.quality) {
            query += ` AND quality = '${req.quality}'`;
        }

        if (req.fromDate && req.toDate) {
            query += `
                AND test_date BETWEEN 
                '${req.fromDate} 00:00:00' 
                AND '${req.toDate} 23:59:59'
            `;
        }

        query += `
            
            ORDER BY id DESC
        `;

        const data = await manager.query(query);

        return new CommonResponse(
            true,
            200,
            'Product counts retrieved successfully',
            data
        );

    } catch (error) {
        return new CommonResponse(false, 500, error.message);
    }
}
    async updateProductCounts(updateDto: UpdateQaqcProductCountsDto | UpdateQaqcProductCountsDto[]): Promise<CommonResponse> {
        try {
            // Handle array of records
            if (Array.isArray(updateDto)) {
                const updatePromises = updateDto.map(async (dto) => {
                    const existing = await this.QAQCProductCountsEntityRepository.findOne({
                        where: { id: dto.id }
                    });

                    if (!existing) {
                        return null;
                    }

                    return await this.QAQCProductCountsEntityRepository.save({
                        ...existing,
                        ...dto
                    });
                });

                const results = await Promise.all(updatePromises);
                const successfulUpdates = results.filter(r => r !== null);

                if (successfulUpdates.length === 0) {
                    return new CommonResponse(false, 404, 'No records found to update');
                }

                return new CommonResponse(true, 200, 'Product counts updated successfully', successfulUpdates);
            } 
            // Handle single record
            else {
                const existing = await this.QAQCProductCountsEntityRepository.findOne({
                    where: { id: updateDto.id }
                });

                if (!existing) {
                    return new CommonResponse(false, 404, 'Record not found');
                }

                const updated = await this.QAQCProductCountsEntityRepository.save({
                    ...existing,
                    ...updateDto
                });

                return new CommonResponse(true, 200, 'Product count updated successfully', updated);
            }
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }

    async approveProductCounts(approvalDto: { ids: number[] }): Promise<CommonResponse> {
        try {
            const manager = getManager();
            if (!approvalDto.ids || approvalDto.ids.length === 0) {
                return new CommonResponse(false, 400, 'No IDs provided for approval');
            }

            const updatePromises = approvalDto.ids.map(async (id) => {
                const existing = await this.QAQCProductCountsEntityRepository.findOne({
                    where: { id }
                });

                if (!existing) {
                    return null;
                }

                return await this.QAQCProductCountsEntityRepository.save({
                    ...existing,
                    isQAQCApproved: true
                });
            });

            const results = await Promise.all(updatePromises);
            const successfulUpdates = results.filter(r => r !== null);

            if (successfulUpdates.length === 0) {
                return new CommonResponse(false, 404, 'No records found to approve');
            }

        const firstRecord: any = successfulUpdates[0];

        await manager.query(
            `UPDATE ${appSettings.production_db}.production_inventory 
             SET is_qaqc_three_approved = 1 
             WHERE lot_number = ? 
             AND operation = ? 
             AND product = ?
             AND entry_type = 'OUT'`,
            [
                firstRecord.lotNumber,
                firstRecord.operation,
                firstRecord.product
            ]
        );


            return new CommonResponse(true, 200, 'Product counts approved successfully', successfulUpdates);
        } catch (error) {
            return new CommonResponse(false, 500, error.message);
        }
    }
}

